export default "__VITE_ASSET__DBeccYeB__"